import {logErrorOnDevEnvironment} from "./Utils";

export default class JsonUtils {

	static parse(string: string): any {
		try {
			return JSON.parse(string);
		}
		catch (error) {
			logErrorOnDevEnvironment(error);
			return undefined;
		}
	}
}
